module.exports = __webpack_public_path__ + "img/3hr-06.3e34545f.jpg";